export default "__VITE_ASSET__CR6Y3Q5q__"